
import requests from '../utils/request'
// 购物车
export const getCarList = (data)=>{
    return requests({
        url:'/buyer/cart/cart/List?isRFQ='+data,
        method:'get',
    })
}

// 添加购物车
export const Add_good = (data)=>{
    return requests({
        url:'/buyer/cart/cart/save',
        method:'post',
        data
    })
}

// 删除购物车
export const del_good = (data)=>{
    return requests({
        url:'/buyer/cart/cart/delete',
        method:'post',
        data
    })
}

// 统计商品

export const count_list = ()=>{
    return requests({
        url:'/buyer/cart/cart/count',
        method:'get',
    })
}